import { getNumArray } from "@/lib/chillnn/get-num-array";

import { FormErrorMessage, FormItem, FormLabel } from "@/components/ui/form/_base/form";

type Props = {
	label?: string;

	value?: string;
	setValue: (value: string) => void;
	errorMessage?: string;

	startAt?: string;
};

export const TimePicker = ({ value = "", setValue, startAt = "", errorMessage, label }: Props) => {
	const localHour = `${value.slice(0, 2)}`;
	const localTime = `${value.slice(-2)}`;

	const startHour = startAt ? Number(startAt.slice(0, 2)) : 0;
	const hours = getNumArray(startHour, 1, 28 - startHour + 1).map((num) => {
		const stringNum = num.toString();
		return stringNum.length === 1 ? `0${stringNum}` : stringNum;
	});

	const times = getNumArray(0, 1, 60).map((num) => {
		const stringNum = num.toString();
		return stringNum.length === 1 ? `0${stringNum}` : stringNum;
	});

	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>

			<div className="flex items-center rounded-lg border border-zinc-200 bg-white text-sm">
				<select
					className="h-10 w-12 appearance-none bg-transparent px-2 py-2 text-center outline-none hover:cursor-pointer hover:rounded-lg hover:bg-zinc-100"
					value={localHour}
					onChange={(e) => {
						const value = e.target.value;
						const time = `${value}:${localTime}`;
						setValue(time);
					}}
				>
					{hours.map((hour) => (
						<option key={hour} value={hour}>
							{hour}
						</option>
					))}
				</select>
				<div>：</div>
				<select
					className="h-10 w-12 appearance-none bg-transparent px-2 py-2 text-center outline-none hover:cursor-pointer hover:rounded-lg hover:bg-zinc-100"
					value={localTime}
					onChange={(e) => {
						const value = e.target.value;
						const time = `${localHour}:${value}`;
						setValue(time);
					}}
				>
					{times.map((time) => (
						<option key={time} value={time}>
							{time}
						</option>
					))}
				</select>
			</div>

			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
